import { Controller } from "@hotwired/stimulus";

/**
 * 指定した値と一致するときだけ content ターゲットを表示するコントローラ
 *
 * Values:
 *   - current  : String  サーバーサイドの初期値（例: "true" / "false"）
 *   - showWhen : String  この値のときに content を表示する（例: "false"）
 *
 * Targets:
 *   - content  : 表示・非表示を切り替える要素（複数可）
 *
 * Actions:
 *   - change->show-if#handleChange  ラジオボタン・セレクト等の change イベントに接続する
 *
 * Usage example:
 *   <div
 *     data-controller="show-if"
 *     data-show-if-current-value="<%= f.object.some_field.to_s %>"
 *     data-show-if-show-when-value="false"
 *   >
 *     <input type="radio" value="true"  data-action="change->show-if#handleChange">
 *     <input type="radio" value="false" data-action="change->show-if#handleChange">
 *     <p data-show-if-target="content">false のときだけ表示される文言</p>
 *   </div>
 *
 * Connects to data-controller="show-if"
 */
export default class extends Controller {
  static targets = ["content"];
  static values = {
    current: String,
    showWhen: String,
  };

  connect() {
    this.#update(this.currentValue);
  }

  // ラジオボタン・セレクト等の change イベントで呼ばれる
  handleChange(event) {
    this.#update(event.target.value);
  }

  #update(value) {
    const visible = value === this.showWhenValue;
    for (const target of this.contentTargets) {
      target.hidden = !visible;
    }
  }
}
